/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Preview_TitleInputs */

const en_directory_platforms_preview_title = /** @type {(inputs: Directory_Platforms_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products available on these platforms`)
};

const zh_directory_platforms_preview_title = /** @type {(inputs: Directory_Platforms_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些平台上的产品`)
};

/**
* | output |
* | --- |
* | "Products available on these platforms" |
*
* @param {Directory_Platforms_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_preview_title = /** @type {((inputs?: Directory_Platforms_Preview_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Preview_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_preview_title(inputs)
	return zh_directory_platforms_preview_title(inputs)
});
export { directory_platforms_preview_title as "directory.platforms.preview_title" }